"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLumpSumPaymentAdjustment = void 0;
const common_1 = require("../../../../../common");
const models_1 = require("../../../models");
function getLumpSumPaymentAdjustment(options) {
    if (options.product !== models_1.InsuranceProduct.AssuranceSelect) {
        return 0;
    }
    if (options.paymentPeriod === common_1.PaymentPeriod.Annually) {
        return 0;
    }
    return options.billingType === common_1.BillingType.DirectBill ? 2 : 0;
}
exports.getLumpSumPaymentAdjustment = getLumpSumPaymentAdjustment;
//# sourceMappingURL=get-lump-sum-payment-adjustment.js.map